import { useSettings } from '@src/data/settings';
import { trpc } from '@src/data/trpc';
import {
  createFileRoute,
  Outlet,
  retainSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';

const giveawaySchema = z.object({
  giveawayId: z.string().optional(),
  showHeader: z.boolean().optional().default(true),
  showAccountAndBalance: z.boolean().optional().default(true),
});

export const Route = createFileRoute('/giveaways/$programId')({
  validateSearch: giveawaySchema,
  search: {
    middlewares: [
      retainSearchParams(['showAccountAndBalance', 'showHeader', 'giveawayId']),
    ],
  },
  loaderDeps: ({ search }) => {
    return { giveawayId: search.giveawayId };
  },
  loader: ({ params, deps }) => {
    return trpc.getRaffleV2.query({
      programId: params.programId,
      giveawayId: deps.giveawayId,
      network: import.meta.env.VITE_NETWORK!,
      userCountry: useSettings.getState().countryCode,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
